import { AgTechIndex } from "@agtech/core/utilities/AgTechUtilities"
import { AgTechContact } from "@agtech/data/contacts/ContactData"
import _ from "lodash"

export type SaleBidder = {
    id: number,
    bidderNumber?: string,
    contactId?: number,
    contact?: AgTechContact,
    saleId?: number
}

export type SaleContactBidder = AgTechContact & {
    bidder?: SaleBidder
}

export type SaleBidderData = {
    bidders: SaleBidder,
    contacts: AgTechIndex<AgTechContact>
}

export type BidderIndex = {
    [id: number]: SaleBidder
}

export type SaleBidderByNumberIndex = {
    [bidderNumber: string]: SaleBidder
}

export type BidderContactIndex = {
    [contactId: number]: number 
}

export type BidderNumberToContactIdIndex = {
    [bidderNumber: string]: number
}

export const DefaultSaleBidder: SaleBidder = {
    id: 0,
    bidderNumber: '',
    contact: undefined
}

export const isSaleBidderTheSame = (prev?: SaleBidder, curr?: SaleBidder) => {
    return prev?.bidderNumber === curr?.bidderNumber &&
           prev?.contact?.id === curr?.contact?.id &&
           prev?.contact?.firstName === curr?.contact?.firstName &&
           prev?.contact?.lastName === curr?.contact?.lastName &&
           prev?.contact?.ranchName === curr?.contact?.ranchName &&
           prev?.contact?.emailAddress === curr?.contact?.emailAddress &&
           prev?.id === curr?.id;
}

export const getNextBidderNumber = (bidders: SaleBidder[]): string => {
    const nextBidderNumber = _.max(
        bidders.filter(bd => bd.bidderNumber)
            .map(bd => parseInt(bd.bidderNumber!))
    ) ?? 0;

    return (nextBidderNumber + 1).toString();
}